import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { SsoAuthService } from './ecan/sso-auth.service';
import { PipesModule } from 'src/pipes/pipes.module';
import { FormErrorService } from './shared/services/form-error.service';
import { ErrorTranslatorService } from './shared/services/error-translator.service';
import { TokenErrorInterceptor } from './authentication/token-error/token-error.interceptor';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule.forRoot(),
    PagesModule,
    AuthenticationModule,
    PipesModule
  ],
  providers: [
    Title,
    SsoAuthService,
    FormErrorService,
    ErrorTranslatorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
